module.exports = __webpack_public_path__ + "img/制御工学5_5_2.c963a268.png";